import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';
import { Workbook, Worksheet } from 'exceljs';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Injectable({
  providedIn: 'root'
})
export class ExcelService {

  constructor() { }

  public exportAsExcelFile(json: any[], excelFileName: string): void {
    const headers: string[] = [];
    json.forEach(row => {
      Object.keys(row || {}).forEach(key => {
        if (headers.indexOf(key) === -1) {
          headers.push(key);
        }
      });
    });

    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('data');
    worksheet.addRow(headers);
    json.forEach(row => {
      worksheet.addRow(headers.map(key => (row ? row[key] : undefined)));
    });

    workbook.xlsx.writeBuffer().then(buffer => {
      this.saveAsExcelFile(buffer, excelFileName);
    });
  }

  // Reads an uploaded Excel file (.xlsx) and returns the first sheet as an array of row objects,
  // keyed by the header row - equivalent to XLSX.utils.sheet_to_json(ws, { raw: false }).
  public readExcelFileAsJson(file: File): Promise<any[]> {
    return new Promise((resolve, reject) => {
      const readFile = new FileReader();
      readFile.onload = () => {
        const workbook = new Workbook();
        workbook.xlsx.load(readFile.result as ArrayBuffer)
          .then(wb => resolve(this.sheetToJson(wb.worksheets[0])))
          .catch(reject);
      };
      readFile.onerror = reject;
      readFile.readAsArrayBuffer(file);
    });
  }

  private sheetToJson(worksheet: Worksheet): any[] {
    const rows: any[] = [];
    if (!worksheet) {
      return rows;
    }
    const headers: string[] = [];
    worksheet.eachRow((row, rowNumber) => {
      if (rowNumber === 1) {
        row.eachCell({ includeEmpty: false }, (cell, colNumber) => {
          headers[colNumber] = (cell.text || '').toString().trim();
        });
        return;
      }
      const obj: any = {};
      row.eachCell({ includeEmpty: false }, (cell, colNumber) => {
        const key = headers[colNumber];
        if (key) {
          obj[key] = cell.text;
        }
      });
      rows.push(obj);
    });
    return rows;
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + EXCEL_EXTENSION);
  }
}
